import script from "./resetpass.vue?vue&type=script&setup=true&lang=js"
export * from "./resetpass.vue?vue&type=script&setup=true&lang=js"

import "./resetpass.vue?vue&type=style&index=0&id=34c87531&lang=scss"

const __exports__ = script;

export default __exports__